import { err, projectProcess, validateRecipe, } from '../domain/index.js';
/**
 * Validates a formula and its process together with the engine (incorporations included), then
 * stores a new immutable revision.
 */
export const saveRevision = async (repository, input) => {
    const valid = validateRecipe(input.formula, input.process);
    if (!valid.ok)
        return valid;
    const projected = projectProcess(input.process, {
        mode: { kind: 'startAt', at: input.createdAt },
    });
    if (!projected.ok)
        return err(projected.error);
    return repository.saveRevision(input);
};
//# sourceMappingURL=recipes.js.map